import { DeviceRobotEntityModel } from "src/store/models/entity/deviceRobot/entity";

export const encooDeviceRobotModels = {
  entity: DeviceRobotEntityModel,
};
